import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e83hfh69gc: FaireBrandEntity = {
  token: "b_e83hfh69gc",
  type: "brand",
  name: "Kristina Bakardina",
  avatarUrl:
    "https://cdn.faire.com/fastly/9e2ac1a725f664db72cfcfd258f8c10e5e3d90aa811156147b72c44fd726c552.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cbc87d274d11e311602679c9735945f70a01a1c40fd98348751f520d16e9c580.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9e2ac1a725f664db72cfcfd258f8c10e5e3d90aa811156147b72c44fd726c552.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cbc87d274d11e311602679c9735945f70a01a1c40fd98348751f520d16e9c580.png",
  location: "Halandale, FL, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Kristina Bakardina is a designer candle brand creating sculptural, hand-poured soy wax candles that double as statement decor. Founded by a visual designer passionate about form, texture, and aesthetics, the brand was created to transform traditional candles into collectible design pieces that elevate modern interiors and retail displays.\n\nEach candle is handmade in small batches using natural soy wax and custom molds that produce distinctive shapes and artistic details. From minimal sculptural silhouettes to playful, conversation-starting designs, every piece is crafted to stand out on shelves and attract attention in curated retail spaces.\n\nRetailers choose Kristina Bakardina for its strong visual merchandising appeal, giftable product range, and unique design language that helps stores differentiate their assortment. The collection performs especially well in boutiques, concept stores, lifestyle shops, museum stores, and gift retailers looking for original, high-impact products customers remember.\n\nKristina Bakardina blends art, craftsmanship, and decor — creating candles that feel special, collectible, and display-worthy.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:43.187Z",
    importedBy: "entity-db-cli",
  },
};
